module.exports = __webpack_public_path__ + "static/media/wireintel.484cb89b.gif";